import ReactGA from "react-ga4";

/** GA4 Measurement ID. Public by design — safe to hardcode. */
const GA_MEASUREMENT_ID = "G-ZGFXXWM7GW";

/** GA4 event parameters. Allows the nested `items` array used by ecommerce events. */
type EventParams = Record<
  string,
  | string
  | number
  | boolean
  | null
  | undefined
  | Array<Record<string, string | number | boolean>>
>;

/** Initialise Google Analytics. Call once at app bootstrap. */
export function initAnalytics() {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

/** Record a SPA page view. */
export function trackPageView(path: string) {
  ReactGA.send({ hitType: "pageview", page: path });
}

/** Record a GA4 event. */
export function trackEvent(name: string, params?: EventParams) {
  ReactGA.event(name, params);
}

/** Associate subsequent events with a user id. No PII (email) is sent, per GA4 policy. */
export function identifyUser(userId: string) {
  ReactGA.gtag("set", { user_id: userId });
}

/** Clear the user id (e.g. on sign-out). */
export function resetUser() {
  ReactGA.gtag("set", { user_id: null });
}
